import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import themestyle from "../theme";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          gap: 3,
        }}
      >
        <ErrorOutlineIcon
          sx={{
            fontSize: 100,
            color: themestyle.colors.activeGreen,
            mb: 2,
          }}
        />
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "64px", md: "120px" },
            fontWeight: 800,
            color: themestyle.colors.primary,
            lineHeight: 1,
          }}
        >
          404
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: themestyle.colors.primary,
          }}
        >
          Oops! Page Not Found
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: themestyle.colors.textSecondary,
            maxWidth: "500px",
            fontSize: "18px",
          }}
        >
          The page you are looking for might have been removed, had its name changed,
          or is temporarily unavailable.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/dashboard")}
          sx={{
            mt: 2,
            px: 4,
            py: 1.5,
            bgcolor: themestyle.colors.buttonGreen,
            borderRadius: "50px",
            fontWeight: 700,
            textTransform: "none",
            fontSize: "16px",
            "&:hover": {
              bgcolor: themestyle.colors.buttonGreenHover,
            },
          }}
        >
          Back to Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default NotFound;
